import styled from 'styled-components';

import noResultImage from '~/src/common/assets/ail.svg';
import MMLoader from '~/src/common/components/Loader';
import { media } from '~/src/styles-constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
  text-align: center;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.common.TEXTS};
`;

export const Image = styled(noResultImage)`
  height: 104px;
`;

// Le terme recherché par l'utilisateur, en gras, avec des quote
export const Term = styled.strong`
  &::before {
    content: '“';
  }

  &::after {
    content: '”';
  }
`;

// Le point n'est visible qu'en mobile. En desktop, il est invisible et
// est utilisé pour forcer un retour à la ligne entre les deux textes
export const Dot = styled.span`
  ${media.XL`
    display: block;
    visibility: hidden;
    line-height: 8px !important;
  `}
`;

export const Loader = styled(MMLoader)`
  margin: 0;
  padding: 0;
`;
